module.exports = __webpack_public_path__ + "static/img/img7.3f9a7db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img7.jpg
// module id = x5O7
// module chunks = 0